/**
 * Spec filter operator symbols sent to API: =, <, >, <=, >=
 */
export type SpecOperator = '=' | '<' | '>' | '<=' | '>=';

/** Rolling time presets (applied at Apply time). */
export type TimePreset = '24h' | '7d' | '30d';

/**
 * Draft/applied filter state for listing search.
 * Maps to API ListingQueryModel; used by useListingSearch and filter UI.
 * specOperators: per-constraint key; for numeric use '>=', '<=', '=' (min/max/exact).
 */
export type SellerAccountTypeFilter = 'Personal' | 'Corporate';

export interface ListingFilterState {
  topCategoryId: number | null;
  secondaryCategoryId: number | null;
  productTypeId: number | null;
  conditionId: number | null;
  cityId: number | null;
  districtId: number | null;
  neighborhoodId: number | null;
  isNew: boolean | null;
  /** null = Tümü; Personal = Bireysel; Corporate = Kurumsal */
  sellerAccountType: SellerAccountTypeFilter | null;
  price: {
    lowerBound?: number | null;
    upperBound?: number | null;
    exactMatch?: number | null;
  };
  specValues: Record<string, string>;
  /** Multi-select enum values for browse filters (CR-015). */
  specMultiValues: Record<string, string[]>;
  specOperators: Record<string, SpecOperator>;
  /** When set, custom range uses `createdAtFrom` (YYYY-MM-DD, İstanbul takvim günü) for "from this date onward". */
  timePreset: TimePreset | null;
  createdAtFrom: string | null;
}

export const defaultListingFilterState: ListingFilterState = {
  topCategoryId: null,
  secondaryCategoryId: null,
  productTypeId: null,
  conditionId: null,
  cityId: null,
  districtId: null,
  neighborhoodId: null,
  isNew: null,
  sellerAccountType: null,
  price: {},
  specValues: {},
  specMultiValues: {},
  specOperators: {},
  timePreset: null,
  createdAtFrom: null,
};
